/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Deft_Rat_TalkInputs */

const en_bold_deft_rat_talk = /** @type {(inputs: Bold_Deft_Rat_TalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Existing access rights will be replaced if they already exist.`)
};

const de_bold_deft_rat_talk = /** @type {(inputs: Bold_Deft_Rat_TalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorhandene Zugriffsrechte werden ersetzt, wenn sie bereits existieren.`)
};

/**
* | output |
* | --- |
* | "Existing access rights will be replaced if they already exist." |
*
* @param {Bold_Deft_Rat_TalkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bold_deft_rat_talk = /** @type {((inputs?: Bold_Deft_Rat_TalkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Deft_Rat_TalkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bold_deft_rat_talk(inputs)
	return de_bold_deft_rat_talk(inputs)
});